import axios from 'axios';

export default class CommonApi {
	constructor() {
		this.api_token = null;
		this.client = null;
		this.api_url =
			window.location.hostname === 'localhost'
				? 'https://webreact.fiu.finfactor.in'
				: window.location.origin;
	}

	getToken() {
		const token = JSON.parse(sessionStorage.getItem('login'))?.token;
		return token;
	}

	init() {
		this.api_token = this.getToken();

		let headers = {
			Authorization: `Bearer ${this.api_token}`,
			Accept: 'application/json',
		};

		this.client = axios.create({
			baseURL: this.api_url,
			timeout: 10000,
			headers: headers,
		});

		return this.client;
	}

	signIn = (data) => {
		return this.init().post(
			`${this.api_url}/finsense/API/V2/User/${process.env.REACT_APP_LOGIN_API}`,
			data
		);
	};
}
